import React from "react";

const stats = [
  { value: "250+", label: "HAPPY CUSTOMERS" },
  { value: "19+", label: "YEARS OF EXPERIENCE" },
  { value: "25+", label: "EMPLOYEES" },
  { value: "100+", label: "PROJECTS COMPLETED" }
];

const HomeSlider = () => {
  return (
    <div className="stats-wrapper">
      <div className="stats-track">
        {[...stats, ...stats, ...stats].map((item, index) => (
          <div className="stat-item" key={index}>
            <h2 className={item.isLogo ? "stat-logo" : "stat-value"}>
              {item.value}
            </h2>
            <p className="stat-label">{item.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomeSlider;
